import React, { useState } from 'react';
import { connect } from 'react-redux';
import FeatureBlockedScreen from "../components/FeatureBlockedScreen";

// ── Replace with your actual deployed Lambda URL ──
const EXTERNAL_API_URL = 'https://external.vacway.es/v1/sales-csv';

// ─────────────────────────────────────────────────────────────────────────────
// Styles (inline, self-contained)
// ─────────────────────────────────────────────────────────────────────────────
const S = {
  page: {
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    background: '#f4f6f9',
    minHeight: '100vh',
    padding: '0 0 60px 0',
  },
  // ── Header ──
  header: {
    background: 'linear-gradient(135deg, #001d3a 0%, #003366 100%)',
    padding: '40px 48px 36px',
    color: '#fff',
    borderBottom: '4px solid #ffae00',
  },
  headerMeta: { display: 'flex', alignItems: 'center', gap: 14, marginBottom: 8 },
  headerBadge: {
    background: '#ffae00',
    color: '#001d3a',
    fontWeight: 700,
    fontSize: 11,
    padding: '3px 10px',
    borderRadius: 20,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  headerVersion: { color: '#7eb8e0', fontSize: 13 },
  headerTitle: { fontSize: 30, fontWeight: 700, margin: '0 0 10px', color: '#fff' },
  headerSubtitle: { color: '#a8c8e8', fontSize: 15, margin: 0, maxWidth: 640 },
  // ── Body ──
  body: { paddingTop: '36px' },
  // ── Section card ──
  card: {
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    marginBottom: 28,
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '16px 24px',
    background: '#001d3a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  cardHeaderIcon: { fontSize: 16, opacity: 0.85 },
  cardHeaderTitle: { fontSize: 15, fontWeight: 600, margin: 0 },
  cardBody: { padding: '22px 24px' },
  // ── Text helpers ──
  sectionTitle: { fontSize: 17, fontWeight: 600, color: '#001d3a', margin: '0 0 12px' },
  para: { color: '#4a5568', fontSize: 14, lineHeight: 1.7, margin: '0 0 12px' },
  label: { fontSize: 13, fontWeight: 600, color: '#001d3a', marginBottom: 4, display: 'block' },
  // ── Method pill ──
  methodPill: {
    display: 'inline-block',
    background: '#28a745',
    color: '#fff',
    fontWeight: 700,
    fontSize: 12,
    padding: '3px 10px',
    borderRadius: 4,
    letterSpacing: 0.5,
    marginRight: 10,
  },
  endpointUrl: {
    display: 'inline-block',
    fontFamily: 'monospace',
    fontSize: 14,
    color: '#001d3a',
    wordBreak: 'break-all',
  },
  endpointBox: {
    background: '#f0f4f8',
    border: '1px solid #d2dce8',
    borderRadius: 6,
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
  },
  // ── Table ──
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: {
    background: '#f0f4f8',
    border: '1px solid #dde4ee',
    padding: '9px 14px',
    textAlign: 'left',
    fontWeight: 600,
    color: '#001d3a',
  },
  td: { border: '1px solid #dde4ee', padding: '9px 14px', color: '#4a5568', verticalAlign: 'top' },
  tdFixed: {
    border: '1px solid #dde4ee', padding: '9px 14px',
    color: '#fff', background: '#001d3a', fontWeight: 600, verticalAlign: 'top',
  },
  tdRequired: {
    border: '1px solid #dde4ee', padding: '9px 14px',
    verticalAlign: 'top',
  },
  codeBadge: {
    background: '#e8edf5',
    color: '#001d3a',
    fontFamily: 'monospace',
    fontSize: 12,
    padding: '2px 7px',
    borderRadius: 4,
    display: 'inline-block',
  },
  requiredBadge: {
    background: '#ffe5e5',
    color: '#c0392b',
    fontSize: 11,
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: 4,
    display: 'inline-block',
  },
  optionalBadge: {
    background: '#e8f5e9',
    color: '#2e7d32',
    fontSize: 11,
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: 4,
    display: 'inline-block',
  },
  fixedBadge: {
    background: '#fff3cd',
    color: '#856404',
    fontSize: 11,
    fontWeight: 600,
    padding: '2px 7px',
    borderRadius: 4,
    display: 'inline-block',
    marginLeft: 6,
  },
  // ── Code block ──
  codeBlock: {
    background: '#0d1117',
    color: '#c9d1d9',
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 13,
    lineHeight: 1.6,
    padding: '18px 20px',
    borderRadius: 8,
    overflowX: 'auto',
    whiteSpace: 'pre',
    margin: 0,
  },
  // ── Tabs ──
  tabBar: { display: 'flex', gap: 4, marginBottom: 14, borderBottom: '2px solid #e8edf5', paddingBottom: 0 },
  tabBtn: (active) => ({
    background: active ? '#001d3a' : 'transparent',
    color: active ? '#fff' : '#666',
    border: 'none',
    borderRadius: '6px 6px 0 0',
    padding: '7px 18px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.15s',
  }),
  // ── Interactive form ──
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  formGridFull: { gridColumn: '1 / -1' },
  input: {
    width: '100%',
    border: '1px solid #cdd5e0',
    borderRadius: 6,
    padding: '9px 12px',
    fontSize: 14,
    color: '#001d3a',
    background: '#fafbfc',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border 0.15s',
  },
  inputReadonly: {
    width: '100%',
    border: '1px solid #cdd5e0',
    borderRadius: 6,
    padding: '9px 12px',
    fontSize: 14,
    color: '#666',
    background: '#f0f4f8',
    boxSizing: 'border-box',
  },
  submitBtn: {
    background: '#001d3a',
    color: '#fff',
    border: 'none',
    borderRadius: 7,
    padding: '11px 28px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 8,
    transition: 'background 0.15s',
  },
  resultBox: (ok) => ({
    background: ok ? '#f0fff4' : '#fff5f5',
    border: `1px solid ${ok ? '#68d391' : '#fc8181'}`,
    borderRadius: 8,
    padding: 16,
    marginTop: 16,
    fontFamily: 'monospace',
    fontSize: 12,
    overflowX: 'auto',
    whiteSpace: 'pre',
    maxHeight: 260,
    overflowY: 'auto',
    color: ok ? '#2d6a4f' : '#c53030',
  }),
  tokenHint: {
    background: '#fff8e1',
    border: '1px solid #ffcc02',
    borderRadius: 6,
    padding: '10px 14px',
    fontSize: 13,
    color: '#5a4a00',
    marginBottom: 14,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
  },
  // ── Status badges ──
  badge200: {
    display: 'inline-block',
    background: '#28a745',
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    padding: '2px 8px',
    borderRadius: 4,
    marginRight: 8,
  },
  badge400: {
    display: 'inline-block',
    background: '#dc3545',
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    padding: '2px 8px',
    borderRadius: 4,
    marginRight: 8,
  },
  badge401: {
    display: 'inline-block',
    background: '#fd7e14',
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    padding: '2px 8px',
    borderRadius: 4,
    marginRight: 8,
  },
  responseRow: {
    padding: '10px 0',
    borderBottom: '1px solid #eef1f6',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    flexWrap: 'wrap',
  },
  responseDesc: { fontSize: 14, color: '#4a5568', flex: 1 },
  // ── Top-level section tabs ──
  sectionTab: (active) => ({
    background: 'transparent',
    color: active ? '#001d3a' : '#6b7280',
    border: 'none',
    borderBottom: active ? '3px solid #ffae00' : '3px solid transparent',
    padding: '16px 28px',
    fontSize: 15,
    fontWeight: active ? 700 : 500,
    cursor: 'pointer',
    transition: 'all 0.15s',
    marginBottom: -2,
  }),
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper: copy to clipboard
// ─────────────────────────────────────────────────────────────────────────────
function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <button
      onClick={handleCopy}
      title="Copiar al portapapeles"
      style={{
        background: copied ? '#28a745' : '#2d3748',
        color: '#fff',
        border: 'none',
        borderRadius: 5,
        padding: '4px 10px',
        fontSize: 11,
        fontWeight: 600,
        cursor: 'pointer',
        float: 'right',
        marginBottom: 6,
        transition: 'background 0.15s',
      }}
    >
      {copied ? '✓ Copiado' : 'Copiar'}
    </button>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// CSV columns definition
// ─────────────────────────────────────────────────────────────────────────────
const CSV_COLUMNS = [
  { col: 'COMPLETE NAME',  desc: 'Nombre completo del cliente'             },
  { col: 'FISCAL NAME',    desc: 'Nombre fiscal / razón social'            },
  { col: 'ADDRESS',        desc: 'Dirección de facturación'                },
  { col: 'ZIP CODE',       desc: 'Código postal'                           },
  { col: 'CITY',           desc: 'Ciudad'                                  },
  { col: 'PROVINCE',       desc: 'Provincia'                               },
  { col: 'VAT NUMBER',     desc: 'NIF / CIF del cliente'                   },
  { col: 'POS ID',         desc: 'Número de serie de la máquina (kiosco)'  },
  { col: 'INVOICE',        desc: 'Código de factura / venta'               },
  { col: 'DATE',           desc: 'Fecha de la venta (DD/MM/YYYY)'          },
  { col: 'TIME',           desc: 'Hora de la venta (HH:MM:SS)'             },
  { col: 'PRODUCT',        desc: 'Descripción del producto / servicio'     },
  { col: 'QUANTITY',       desc: 'Cantidad de unidades'                    },
  { col: 'UNIT PRICE',     desc: 'Precio unitario (sin IVA)'               },
  { col: 'BASE PRICE',     desc: 'Precio base total (sin IVA)'             },
  { col: 'VAT %',          desc: 'Porcentaje de IVA aplicado'              },
  { col: 'VAT PRICE',      desc: 'Importe del IVA'                         },
  { col: 'TIPO PAGO',      desc: 'Método de pago (CARD, CASH, QR, PDA…)'  },
  { col: 'TOTAL',          desc: 'Importe total de la venta (con IVA)'     },
];

// ─────────────────────────────────────────────────────────────────────────────
// Code examples
// ─────────────────────────────────────────────────────────────────────────────
const CURL_EXAMPLE = `curl -X POST "${EXTERNAL_API_URL}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_TOKEN_HERE" \\
  -d '{
    "MachineType": "lockers",
    "StartDate": "2024-01-01",
    "EndDate": "2024-01-31"
  }' \\
  --output sales-lockers-jan2024.txt`;

const JS_EXAMPLE = `const response = await fetch("${EXTERNAL_API_URL}", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer YOUR_TOKEN_HERE"
  },
  body: JSON.stringify({
    MachineType: "lockers",
    StartDate: "2024-01-01",
    EndDate: "2024-01-31"
  })
});

if (!response.ok) {
  const err = await response.json();
  throw new Error(err.message);
}

// Download as file
const text  = await response.text();
const blob  = new Blob([text], { type: "text/plain" });
const url   = URL.createObjectURL(blob);
const link  = document.createElement("a");
link.href     = url;
link.download = "sales-lockers.txt";
link.click();
URL.revokeObjectURL(url);`;

const PYTHON_EXAMPLE = `import requests

url = "${EXTERNAL_API_URL}"

headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer YOUR_TOKEN_HERE"
}

payload = {
    "MachineType": "lockers",
    "StartDate": "2024-01-01",
    "EndDate": "2024-01-31"
}

response = requests.post(url, json=payload, headers=headers)

if response.status_code == 200:
    with open("sales-lockers.txt", "w", encoding="utf-8") as f:
        f.write(response.text)
    print("Sales data downloaded successfully")
else:
    print(f"Error {response.status_code}: {response.json()}")`;

const PHP_EXAMPLE = `<?php
$url     = "${EXTERNAL_API_URL}";
$token   = "YOUR_TOKEN_HERE";

$payload = json_encode([
    "MachineType" => "lockers",
    "StartDate"   => "2024-01-01",
    "EndDate"     => "2024-01-31",
]);

$ch = curl_init($url);
curl_setopt_array($ch, [
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_POST           => true,
    CURLOPT_POSTFIELDS     => $payload,
    CURLOPT_HTTPHEADER     => [
        "Content-Type: application/json",
        "Authorization: Bearer {$token}",
    ],
]);

$response   = curl_exec($ch);
$statusCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);
curl_close($ch);

if ($statusCode === 200) {
    file_put_contents("sales-lockers.txt", $response);
    echo "Sales data downloaded successfully.\\n";
} else {
    $err = json_decode($response, true);
    echo "Error {$statusCode}: " . ($err["message"] ?? "Unknown error") . "\\n";
}`;

const EXAMPLES = {
  curl:   { label: 'cURL',       lang: 'bash',   code: CURL_EXAMPLE   },
  js:     { label: 'JavaScript', lang: 'js',     code: JS_EXAMPLE     },
  python: { label: 'Python',     lang: 'python', code: PYTHON_EXAMPLE },
  php:    { label: 'PHP',        lang: 'php',    code: PHP_EXAMPLE    },
};

// ─────────────────────────────────────────────────────────────────────────────
// Redeem Codes API — constants & examples
// ─────────────────────────────────────────────────────────────────────────────
const REDEEMCODES_API_URL = 'https://redeemcodes-api.vacway.com/v1/redeemcodes/create';

const RC_BODY_EXAMPLE = `{
  "origin": "external",
  "products": [
    {
      "product_name": "BNS",
      "product_qty": 1,
      "product_price": 10.00
    }
  ],
  "code": "A1B2C3",
  "valid_from": "2026-04-08T00:00:00Z",
  "valid_to": "2026-04-15T23:59:59Z",
  "machineType": "locker"
}`;

const RC_CURL_EXAMPLE = `curl -X POST "${REDEEMCODES_API_URL}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_TOKEN_HERE" \\
  -d '{
    "origin": "external",
    "products": [
      {
        "product_name": "BNS",
        "product_qty": 1,
        "product_price": 10.00
      }
    ],
    "code": "A1B2C3",
    "valid_from": "2026-04-08T00:00:00Z",
    "valid_to": "2026-04-15T23:59:59Z",
    "machineType": "locker"
  }'`;

const RC_JS_EXAMPLE = `const response = await fetch("${REDEEMCODES_API_URL}", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer YOUR_TOKEN_HERE"
  },
  body: JSON.stringify({
    origin: "external",
    products: [
      { product_name: "BNS", product_qty: 1, product_price: 10.00 }
    ],
    code: "A1B2C3",
    valid_from: "2026-04-08T00:00:00Z",   // optional — omit for no start restriction
    valid_to: "2026-04-15T23:59:59Z",     // optional — omit for no expiry
    machineType: "locker"
  })
});

const data = await response.json();
console.log(data);
// { message: "Redeem code created successfully", id: "...", code: "A1B2C3" }`;

const RC_PYTHON_EXAMPLE = `import requests

url = "${REDEEMCODES_API_URL}"

headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer YOUR_TOKEN_HERE"
}

payload = {
    "origin": "external",
    "products": [
        {
            "product_name": "BNS",
            "product_qty": 1,
            "product_price": 10.00
        }
    ],
    "code": "A1B2C3",
    "valid_from": "2026-04-08T00:00:00Z",   # optional
    "valid_to": "2026-04-15T23:59:59Z",     # optional
    "machineType": "locker"
}

response = requests.post(url, json=payload, headers=headers)
data = response.json()
print(data)
# {'message': 'Redeem code created successfully', 'id': '...', 'code': 'A1B2C3'}`;

const RC_PHP_EXAMPLE = `<?php
$url   = "${REDEEMCODES_API_URL}";
$token = "YOUR_TOKEN_HERE";

$payload = json_encode([
    "origin"   => "external",
    "products" => [
        [
            "product_name"  => "BNS",
            "product_qty"   => 1,
            "product_price" => 10.00,
        ],
    ],
    "code"        => "A1B2C3",
    "valid_from"  => "2026-04-08T00:00:00Z",   // optional
    "valid_to"    => "2026-04-15T23:59:59Z",   // optional
    "machineType" => "locker",
]);

$ch = curl_init($url);
curl_setopt_array($ch, [
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_POST           => true,
    CURLOPT_POSTFIELDS     => $payload,
    CURLOPT_HTTPHEADER     => [
        "Content-Type: application/json",
        "Authorization: Bearer {$token}",
    ],
]);

$response   = curl_exec($ch);
$statusCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);
curl_close($ch);

$data = json_decode($response, true);
print_r($data);
// Array ( [message] => Redeem code created successfully [id] => ... [code] => A1B2C3 )`;

const RC_EXAMPLES = {
  curl:   { label: 'cURL',       code: RC_CURL_EXAMPLE   },
  js:     { label: 'JavaScript', code: RC_JS_EXAMPLE     },
  python: { label: 'Python',     code: RC_PYTHON_EXAMPLE },
  php:    { label: 'PHP',        code: RC_PHP_EXAMPLE    },
};

// ─────────────────────────────────────────────────────────────────────────────
// Available product codes
// ─────────────────────────────────────────────────────────────────────────────
const PRODUCT_CODES = [
  { code: 'BNS',   label: 'Standard' },
  { code: 'CNS',   label: 'Standard Carga' },
  { code: 'BWS',   label: 'Standard XL' },
  { code: 'CWS',   label: 'Standard Carga XL' },
  { code: 'BNM',   label: 'Medium' },
  { code: 'CNM',   label: 'Medium Carga' },
  { code: 'BWM',   label: 'Medium XL' },
  { code: 'CWM',   label: 'Medium Carga XL' },
  { code: 'BNL',   label: 'Large' },
  { code: 'CNL',   label: 'Large Carga' },
  { code: 'BWL',   label: 'Large XL' },
  { code: 'CWL',   label: 'Large Carga XL' },
  { code: 'BNXL',  label: 'Large 4' },
  { code: 'CNXL',  label: 'Large 4 Carga' },
  { code: 'BWXL',  label: 'Large 4 XL' },
  { code: 'CWXL',  label: 'Large 4 Carga XL' },
  { code: 'BN2XL', label: 'Large 5' },
  { code: 'CN2XL', label: 'Large 5 Carga' },
  { code: 'BW2XL', label: 'Large 5 XL' },
  { code: 'CW2XL', label: 'Large 5 Carga XL' },
  { code: 'BN3XL', label: 'Ski' },
  { code: 'CN3XL', label: 'Ski Carga' },
  { code: 'BW3XL', label: 'Ski XL' },
  { code: 'CW3XL', label: 'Ski Carga XL' },
  { code: 'XNS',   label: 'Standard Cupón' },
  { code: 'XWS',   label: 'Standard XL Cupón' },
  { code: 'XNM',   label: 'Medium Cupón' },
  { code: 'XWM',   label: 'Medium XL Cupón' },
  { code: 'XNL',   label: 'Large Cupón' },
  { code: 'XWL',   label: 'Large XL Cupón' },
  { code: 'XNXL',  label: 'Large 4 Cupón' },
  { code: 'XWXL',  label: 'Large 4 XL Cupón' },
  { code: 'XN2XL', label: 'Large 5 Cupón' },
  { code: 'XW2XL', label: 'Large 5 XL Cupón' },
  { code: 'XN3XL', label: 'Ski Cupón' },
  { code: 'XW3XL', label: 'Ski XL Cupón' },
];

// ─────────────────────────────────────────────────────────────────────────────
// RedeemCodesSection — self-contained documentation panel
// ─────────────────────────────────────────────────────────────────────────────
const RedeemCodesSection = ({ role, customer }) => {
  if (role === 'CUSTOMER' && customer && customer.FeatureRedeemCodes === false) {
    return <FeatureBlockedScreen featureName="FeatureRedeemCodes" featureLabel="Códigos Canjeables" />;
  }
  const [activeTab,    setActiveTab]    = useState('curl');
  const [code,         setCode]         = useState('');
  const [productName,  setProductName]  = useState('');
  const [productQty,   setProductQty]   = useState('1');
  const [productPrice, setProductPrice] = useState('');
  const [validFrom,    setValidFrom]    = useState('');
  const [validTo,      setValidTo]      = useState('');
  const [authToken,    setAuthToken]    = useState('');
  const [showToken,      setShowToken]      = useState(false);
  const [loading,        setLoading]        = useState(false);
  const [result,         setResult]         = useState(null);
  const [showCodesModal, setShowCodesModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code || !productName || !authToken) return;

    setLoading(true);
    setResult(null);

    const product = { product_name: productName, product_qty: 1 };
    if (productPrice) product.product_price = Number(productPrice);

    const body = {
      origin: 'external',
      products: [product],
      code,
      machineType: 'locker',
    };
    if (validFrom) body.valid_from = new Date(validFrom).toISOString();
    if (validTo)   body.valid_to   = new Date(validTo).toISOString();

    try {
      const response = await fetch(REDEEMCODES_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken.trim()}`,
        },
        body: JSON.stringify(body),
      });
      const data = await response.json().catch(() => ({ message: 'Could not parse response' }));
      if (!response.ok) {
        setResult({ ok: false, text: `Error ${response.status}: ${data.message || JSON.stringify(data)}` });
      } else {
        setResult({ ok: true, text: JSON.stringify(data, null, 2) });
      }
    } catch (err) {
      setResult({ ok: false, text: `Network error: ${err.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ── Overview ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-info-circle" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Resumen</h3>
        </div>
        <div style={S.cardBody}>
          <p style={S.para}>
            La API de <strong>Redeem Codes</strong> permite generar códigos de canje que los
            usuarios pueden introducir en las máquinas locker VACWAY para acceder a productos
            o servicios. Cada código puede llevar asociado uno o varios productos y,
            opcionalmente, un rango de fechas de validez.
          </p>
          <p style={{ ...S.para, marginBottom: 0 }}>
            Si no se proporcionan las fechas <code style={S.codeBadge}>valid_from</code> /
            {' '}<code style={S.codeBadge}>valid_to</code>, el código no tiene restricción
            temporal y puede canjearse en cualquier momento.
          </p>
        </div>
      </div>

      {/* ── Endpoint ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-plug" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Endpoint</h3>
        </div>
        <div style={S.cardBody}>
          <div style={S.endpointBox}>
            <span style={S.methodPill}>POST</span>
            <span style={S.endpointUrl}>{REDEEMCODES_API_URL}</span>
          </div>
          <h4 style={{ ...S.sectionTitle, marginTop: 20 }}>Headers requeridos</h4>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Header</th>
                <th style={S.th}>Valor</th>
                <th style={S.th}>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>Content-Type</code></td>
                <td style={S.td}><code style={S.codeBadge}>application/json</code></td>
                <td style={S.td}>Formato del cuerpo de la petición</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>Authorization</code></td>
                <td style={S.td}><code style={S.codeBadge}>Bearer &lt;token&gt;</code></td>
                <td style={S.td}>Client token de autenticación VACWAY</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Request body ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-file-code" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Cuerpo de la petición (JSON)</h3>
        </div>
        <div style={S.cardBody}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Campo</th>
                <th style={S.th}>Tipo</th>
                <th style={S.th}>Estado</th>
                <th style={S.th}>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>origin</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.fixedBadge}>FIJO: "external"</span></td>
                <td style={S.td}>Origen de la petición. Siempre <code style={S.codeBadge}>external</code> para integraciones API.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>products</code></td>
                <td style={S.td}><code style={S.codeBadge}>array</code></td>
                <td style={S.tdRequired}><span style={S.requiredBadge}>REQUERIDO</span></td>
                <td style={S.td}>Lista de productos asociados al código. Cada elemento debe incluir <code style={S.codeBadge}>product_name</code>. Los campos <code style={S.codeBadge}>product_qty</code> y <code style={S.codeBadge}>product_price</code> son opcionales.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>products[].product_name</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.requiredBadge}>REQUERIDO</span></td>
                <td style={S.td}>Nombre o código del producto (ej. <code style={S.codeBadge}>BNS</code>).</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>products[].product_qty</code></td>
                <td style={S.td}><code style={S.codeBadge}>number</code></td>
                <td style={S.tdRequired}><span style={S.fixedBadge}>FIJO: 1</span></td>
                <td style={S.td}>Cantidad de unidades del producto. Actualmente limitado a <code style={S.codeBadge}>1</code>.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>products[].product_price</code></td>
                <td style={S.td}><code style={S.codeBadge}>number</code></td>
                <td style={S.tdRequired}><span style={S.optionalBadge}>OPCIONAL</span></td>
                <td style={S.td}>Precio unitario del producto.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>code</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.requiredBadge}>REQUERIDO</span></td>
                <td style={S.td}>Código único que el usuario introducirá en la máquina (ej. <code style={S.codeBadge}>A1B2C3</code>). Debe ser único en el sistema.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>valid_from</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.optionalBadge}>OPCIONAL</span></td>
                <td style={S.td}>Fecha/hora de inicio de validez en ISO 8601 (ej. <code style={S.codeBadge}>2026-04-08T00:00:00Z</code>). Si se omite, no hay restricción de fecha de inicio.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>valid_to</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.optionalBadge}>OPCIONAL</span></td>
                <td style={S.td}>Fecha/hora de fin de validez en ISO 8601 (ej. <code style={S.codeBadge}>2026-04-15T23:59:59Z</code>). Si se omite, el código no caduca.</td>
              </tr>
              <tr>
                <td style={S.td}><code style={S.codeBadge}>machineType</code></td>
                <td style={S.td}><code style={S.codeBadge}>string</code></td>
                <td style={S.tdRequired}><span style={S.fixedBadge}>FIJO: "locker"</span></td>
                <td style={S.td}>Tipo de máquina donde se puede canjear el código.</td>
              </tr>
            </tbody>
          </table>
          <h4 style={{ ...S.sectionTitle, marginTop: 22 }}>Ejemplo de cuerpo</h4>
          <div style={{ position: 'relative' }}>
            <CopyButton text={RC_BODY_EXAMPLE} />
            <pre style={S.codeBlock}>{RC_BODY_EXAMPLE}</pre>
          </div>
        </div>
      </div>

      {/* ── Response ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-reply" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Respuesta</h3>
        </div>
        <div style={S.cardBody}>
          <div style={S.responseRow}>
            <span style={S.badge200}>201 Created</span>
            <span style={S.responseDesc}>Código creado correctamente. JSON con el mensaje de confirmación, el ID interno y el código.</span>
          </div>
          <div style={S.responseRow}>
            <span style={S.badge401}>401 Unauthorized</span>
            <span style={S.responseDesc}>Token ausente o inválido.</span>
          </div>
          <div style={{ ...S.responseRow, borderBottom: 'none' }}>
            <span style={S.badge400}>400 Bad Request</span>
            <span style={S.responseDesc}>
              Algún campo requerido falta o el código ya existe.{' '}
              <code style={S.codeBadge}>{`{ "message": "..." }`}</code>
            </span>
          </div>
          <h4 style={{ ...S.sectionTitle, marginTop: 22 }}>Ejemplo de respuesta exitosa</h4>
          <div style={{ position: 'relative' }}>
            <CopyButton text={`{\n  "message": "Redeem code created successfully",\n  "id": "69d7a2eaf08bd904be37045d",\n  "code": "A1B2C3"\n}`} />
            <pre style={S.codeBlock}>{`{
  "message": "Redeem code created successfully",
  "id": "69d7a2eaf08bd904be37045d",
  "code": "A1B2C3"
}`}</pre>
          </div>
        </div>
      </div>

      {/* ── Code examples ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-code" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Ejemplos de código</h3>
        </div>
        <div style={S.cardBody}>
          <div style={S.tabBar}>
            {Object.entries(RC_EXAMPLES).map(([key, { label }]) => (
              <button key={key} style={S.tabBtn(activeTab === key)} onClick={() => setActiveTab(key)}>
                {label}
              </button>
            ))}
          </div>
          <div style={{ position: 'relative' }}>
            <CopyButton text={RC_EXAMPLES[activeTab].code} />
            <pre style={S.codeBlock}>{RC_EXAMPLES[activeTab].code}</pre>
          </div>
        </div>
      </div>

      {/* ── Interactive test form ── */}
      <div style={S.card}>
        <div style={{ ...S.cardHeader, background: '#003d6b' }}>
          <i className="fa fa-play-circle" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Probar petición</h3>
        </div>
        <div style={S.cardBody}>
          <div style={S.tokenHint}>
            <i className="fa fa-info-circle" style={{ marginTop: 2, flexShrink: 0 }} />
            <span>
              Introduce tu <strong>client token</strong>. El campo <code style={S.codeBadge}>code</code> debe
              ser único — usar el mismo código dos veces devolverá un error.
              Las fechas son opcionales; si las dejas vacías el código no tendrá restricción temporal.
            </span>
          </div>
          <form onSubmit={handleSubmit}>
            <div style={S.formGrid}>
              {/* Origin (fixed) */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-lock" style={{ marginRight: 6, color: '#ffae00' }} />
                  Origin <span style={S.fixedBadge}>FIJO</span>
                </label>
                <input style={S.inputReadonly} type="text" value="external" readOnly />
              </div>
              {/* MachineType (fixed) */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-lock" style={{ marginRight: 6, color: '#ffae00' }} />
                  Machine type <span style={S.fixedBadge}>FIJO</span>
                </label>
                <input style={S.inputReadonly} type="text" value="locker" readOnly />
              </div>
              {/* Code */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-ticket" style={{ marginRight: 6 }} />
                  Código de canje <span style={S.requiredBadge}>requerido</span>
                </label>
                <input
                  style={S.input}
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Ej. A1B2C3"
                  required
                />
              </div>
              {/* Product name */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-tag" style={{ marginRight: 6 }} />
                  Nombre producto <span style={S.requiredBadge}>requerido</span>
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    style={{ ...S.input, flex: 1 }}
                    type="text"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    placeholder="Ej. BNS"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowCodesModal(true)}
                    title="Ver códigos disponibles"
                    style={{
                      background: '#001d3a',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      padding: '0 14px',
                      cursor: 'pointer',
                      fontSize: 13,
                      fontWeight: 600,
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                    }}
                  >
                    <i className="fa fa-list" style={{ marginRight: 6 }} />
                    Ver códigos
                  </button>
                </div>
              </div>
              {/* Product qty — fixed to 1 */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-hashtag" style={{ marginRight: 6, color: '#ffae00' }} />
                  Cantidad <span style={S.fixedBadge}>FIJO: 1</span>
                </label>
                <input style={S.inputReadonly} type="text" value="1" readOnly />
              </div>
              {/* Product price */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-eur" style={{ marginRight: 6 }} />
                  Precio unitario <span style={S.optionalBadge}>opcional</span>
                </label>
                <input
                  style={S.input}
                  type="number"
                  min="0"
                  step="0.01"
                  value={productPrice}
                  onChange={(e) => setProductPrice(e.target.value)}
                  placeholder="Ej. 10.00"
                />
              </div>
              {/* valid_from */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-calendar" style={{ marginRight: 6 }} />
                  Válido desde <span style={S.optionalBadge}>opcional</span>
                </label>
                <input
                  style={S.input}
                  type="datetime-local"
                  value={validFrom}
                  onChange={(e) => setValidFrom(e.target.value)}
                />
              </div>
              {/* valid_to */}
              <div>
                <label style={S.label}>
                  <i className="fa fa-calendar-times-o" style={{ marginRight: 6 }} />
                  Válido hasta <span style={S.optionalBadge}>opcional</span>
                </label>
                <input
                  style={S.input}
                  type="datetime-local"
                  value={validTo}
                  onChange={(e) => setValidTo(e.target.value)}
                />
              </div>
              {/* Auth token */}
              <div style={S.formGridFull}>
                <label style={S.label}>
                  <i className="fa fa-shield" style={{ marginRight: 6 }} />
                  Token de autorización <span style={S.requiredBadge}>requerido</span>
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    style={{ ...S.input, flex: 1, fontFamily: 'monospace', fontSize: 12 }}
                    type={showToken ? 'text' : 'password'}
                    autoComplete="new-password"
                    value={authToken}
                    onChange={(e) => setAuthToken(e.target.value)}
                    placeholder="Pega aquí tu Bearer token..."
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowToken(!showToken)}
                    style={{
                      background: '#e8edf5',
                      border: '1px solid #cdd5e0',
                      borderRadius: 6,
                      padding: '0 14px',
                      cursor: 'pointer',
                      color: '#4a5568',
                      fontSize: 13,
                      flexShrink: 0,
                    }}
                    title={showToken ? 'Ocultar token' : 'Mostrar token'}
                  >
                    <i className={`fa fa-eye${showToken ? '-slash' : ''}`} />
                  </button>
                </div>
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <button
                type="submit"
                disabled={loading}
                style={{ ...S.submitBtn, opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
              >
                {loading
                  ? <><i className="fa fa-spinner fa-spin" /> Creando código…</>
                  : <><i className="fa fa-paper-plane" /> Crear Redeem Code</>
                }
              </button>
            </div>
          </form>
          {result && (
            <div>
              <div style={{ marginTop: 18, marginBottom: 6, fontSize: 13, fontWeight: 600, color: '#001d3a' }}>
                {result.ok ? 'Respuesta:' : 'Error:'}
              </div>
              <div style={S.resultBox(result.ok)}>{result.text}</div>
            </div>
          )}
        </div>
      </div>

      {/* ── Notes ── */}
      <div style={S.card}>
        <div style={S.cardHeader}>
          <i className="fa fa-lightbulb-o" style={S.cardHeaderIcon} />
          <h3 style={S.cardHeaderTitle}>Notas y buenas prácticas</h3>
        </div>
        <div style={S.cardBody}>
          <ul style={{ color: '#4a5568', fontSize: 14, lineHeight: 1.9, paddingLeft: 20, margin: 0 }}>
            <li>
              El campo <code style={S.codeBadge}>code</code> debe ser único. Si ya existe un código
              con el mismo valor, la API devolverá un error.
            </li>
            <li>
              Si no envías <code style={S.codeBadge}>valid_from</code> ni{' '}
              <code style={S.codeBadge}>valid_to</code>, el código no tiene restricción temporal
              y puede canjearse en cualquier momento.
            </li>
            <li>
              Las fechas deben enviarse en formato ISO 8601 con zona horaria (UTC recomendado):{' '}
              <code style={S.codeBadge}>2026-04-08T00:00:00Z</code>.
            </li>
            <li>
              El array <code style={S.codeBadge}>products</code> admite múltiples entradas, aunque
              en el caso típico se incluye un único producto.
            </li>
            <li>
              El campo <code style={S.codeBadge}>origin</code> debe ser siempre{' '}
              <code style={S.codeBadge}>external</code> para peticiones API externas.
            </li>
          </ul>
        </div>
      </div>

      {/* ── Product codes modal ── */}
      {showCodesModal && (
        <div
          onClick={() => setShowCodesModal(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: 10, width: '100%', maxWidth: 560,
              maxHeight: '80vh', display: 'flex', flexDirection: 'column',
              boxShadow: '0 8px 40px rgba(0,0,0,0.25)', overflow: 'hidden',
            }}
          >
            <div style={{
              background: '#001d3a', color: '#fff', padding: '16px 24px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <span style={{ fontWeight: 700, fontSize: 15 }}>
                <i className="fa fa-list" style={{ marginRight: 8 }} />
                Códigos de producto disponibles
              </span>
              <button
                onClick={() => setShowCodesModal(false)}
                style={{
                  background: 'transparent', border: 'none', color: '#fff',
                  fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: 0,
                }}
              >×</button>
            </div>
            <div style={{ overflowY: 'auto', padding: '16px 24px' }}>
              <p style={{ ...S.para, marginBottom: 16 }}>
                Haz clic en un código para seleccionarlo en el formulario.
              </p>
              <table style={S.table}>
                <thead>
                  <tr>
                    <th style={S.th}>Código</th>
                    <th style={S.th}>Descripción</th>
                    <th style={{ ...S.th, width: 80 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {PRODUCT_CODES.map(({ code: c, label }) => (
                    <tr key={c} style={{ cursor: 'pointer' }} onClick={() => { setProductName(c); setShowCodesModal(false); }}>
                      <td style={S.td}><code style={S.codeBadge}>{c}</code></td>
                      <td style={S.td}>{label}</td>
                      <td style={{ ...S.td, textAlign: 'center' }}>
                        <button
                          type="button"
                          style={{
                            background: productName === c ? '#001d3a' : '#e8edf5',
                            color: productName === c ? '#fff' : '#001d3a',
                            border: 'none', borderRadius: 5,
                            padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                          }}
                        >
                          {productName === c ? '✓ Seleccionado' : 'Usar'}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// Main component
// ─────────────────────────────────────────────────────────────────────────────
const ApiDocsView = ({ role, customer }) => {
  const [activeSection, setActiveSection] = useState('sales');
  const [activeTab, setActiveTab] = useState('curl');
  const [startDate, setStartDate]   = useState('');
  const [endDate,   setEndDate]     = useState('');
  const [authToken, setAuthToken]   = useState('');
  const [showToken, setShowToken]   = useState(false);
  const [loading,   setLoading]     = useState(false);
  const [result,    setResult]      = useState(null);  // { ok, text }
  const [autoDownloaded, setAutoDownloaded] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate || !authToken) return;

    setLoading(true);
    setResult(null);
    setAutoDownloaded(false);

    try {
      const response = await fetch(EXTERNAL_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken.trim()}`,
        },
        body: JSON.stringify({
          MachineType: 'lockers',
          StartDate: startDate,
          EndDate: endDate,
        }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({ message: 'Unknown error' }));
        setResult({ ok: false, text: `Error ${response.status}: ${errData.message}` });
        return;
      }

      const text = await response.text();
      const lineCount = text.split('\n').filter(Boolean).length - 1; // exclude header
      setResult({ ok: true, text, lineCount });

      // Auto-trigger CSV download
      const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `sales-lockers-${startDate}-${endDate}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setAutoDownloaded(true);
    } catch (err) {
      setResult({ ok: false, text: `Network error: ${err.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>

      {/* ── Header ── */}
      <div style={S.header}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24 }}>
          <div>
            <div style={S.headerMeta}>
              <span style={S.headerBadge}>REST API</span>
              <span style={S.headerVersion}>v1  ·  Lockers</span>
            </div>
            <h1 style={S.headerTitle}>
              <i className="fa fa-code" style={{ marginRight: 12 }} />
              Documentación API — Integraciones VACWAY
            </h1>
          </div>
          <p style={{ ...S.headerSubtitle, maxWidth: 420, margin: 0 }}>
            Conecta sistemas externos con VACWAY mediante nuestra API REST. Consulta
            la documentación de cada integración disponible en las pestañas de abajo.
          </p>
        </div>
      </div>

      {/* ── Section tabs ── */}
      <div style={{ background: '#fff', borderBottom: '2px solid #e8edf5', padding: '0 48px', display: 'flex', gap: 0 }}>
        <button style={S.sectionTab(activeSection === 'sales')} onClick={() => setActiveSection('sales')}>
          <i className="fa fa-bar-chart" style={{ marginRight: 8 }} />
          Ventas CSV
        </button>
        <button style={S.sectionTab(activeSection === 'redeemcodes')} onClick={() => setActiveSection('redeemcodes')}>
          <i className="fa fa-ticket" style={{ marginRight: 8 }} />
          Redeem Codes
        </button>
      </div>

      <div style={S.body}>

        {activeSection === 'sales' && (<>

        {/* ── Overview ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-info-circle" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Resumen</h3>
          </div>
          <div style={S.cardBody}>
            <p style={S.para}>
              La API externa de Vacway expone un único endpoint que devuelve un archivo de texto
              con las ventas de tus lockers para el rango de fechas indicado. Cada fila corresponde
              a una venta y el separador de campos es la <strong>coma (,)</strong>.
            </p>
            <p style={{ ...S.para, marginBottom: 0 }}>
              El tipo de máquina está fijado a <code style={S.codeBadge}>lockers</code> — no es
              necesario especificar otro valor.
            </p>
          </div>
        </div>

        {/* ── Endpoint ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-plug" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Endpoint</h3>
          </div>
          <div style={S.cardBody}>
            <div style={S.endpointBox}>
              <span style={S.methodPill}>POST</span>
              <span style={S.endpointUrl}>{EXTERNAL_API_URL}</span>
            </div>

            {/* Headers table */}
            <h4 style={{ ...S.sectionTitle, marginTop: 20 }}>Headers requeridos</h4>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Header</th>
                  <th style={S.th}>Valor</th>
                  <th style={S.th}>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={S.td}><code style={S.codeBadge}>Content-Type</code></td>
                  <td style={S.td}><code style={S.codeBadge}>application/json</code></td>
                  <td style={S.td}>Formato del cuerpo de la petición</td>
                </tr>
                <tr>
                  <td style={S.td}><code style={S.codeBadge}>Authorization</code></td>
                  <td style={S.td}><code style={S.codeBadge}>Bearer &lt;token&gt;</code></td>
                  <td style={S.td}>Token de autenticación JWT de tu cuenta Vacway</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Authentication ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-key" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Autenticación</h3>
          </div>
          <div style={S.cardBody}>
            <p style={S.para}>
              Todas las peticiones deben incluir un header <strong>Authorization</strong> con
              el prefijo <code style={S.codeBadge}>Bearer</code> seguido de tu token JWT.
              El token identifica tu cuenta de cliente y es usado internamente para filtrar
              únicamente las ventas asociadas a tu organización.
            </p>
            <p style={S.para}>
              Puedes obtener tu token iniciando sesión en el panel de Vacway. El token activo
              de tu sesión actual está disponible en la sección{' '}
              <strong>Probar petición</strong> más abajo.
            </p>
            <div style={{
              background: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: 7,
              padding: '12px 16px',
              fontSize: 13,
              color: '#856404',
              display: 'flex',
              gap: 10,
              alignItems: 'flex-start',
            }}>
              <i className="fa fa-exclamation-triangle" style={{ marginTop: 2 }} />
              <span>
                <strong>Aviso de seguridad:</strong> Mantén tu token en secreto. No lo compartas
                ni lo incluyas en repositorios de código. Si crees que tu token está comprometido,
                contacta con soporte.
              </span>
            </div>
          </div>
        </div>

        {/* ── Request body ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-file-code" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Cuerpo de la petición (JSON)</h3>
          </div>
          <div style={S.cardBody}>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Campo</th>
                  <th style={S.th}>Tipo</th>
                  <th style={S.th}>Estado</th>
                  <th style={S.th}>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={S.td}><code style={S.codeBadge}>MachineType</code></td>
                  <td style={S.td}><code style={S.codeBadge}>string</code></td>
                  <td style={S.tdRequired}>
                    <span style={S.fixedBadge}>FIJO: "lockers"</span>
                  </td>
                  <td style={S.td}>
                    Tipo de máquina. Para este acceso siempre debe ser{' '}
                    <code style={S.codeBadge}>lockers</code>.
                  </td>
                </tr>
                <tr>
                  <td style={S.td}><code style={S.codeBadge}>StartDate</code></td>
                  <td style={S.td}><code style={S.codeBadge}>string</code></td>
                  <td style={S.tdRequired}>
                    <span style={S.requiredBadge}>REQUERIDO</span>
                  </td>
                  <td style={S.td}>
                    Fecha de inicio del rango. Formato ISO 8601:{' '}
                    <code style={S.codeBadge}>YYYY-MM-DD</code>
                  </td>
                </tr>
                <tr>
                  <td style={S.td}><code style={S.codeBadge}>EndDate</code></td>
                  <td style={S.td}><code style={S.codeBadge}>string</code></td>
                  <td style={S.tdRequired}>
                    <span style={S.requiredBadge}>REQUERIDO</span>
                  </td>
                  <td style={S.td}>
                    Fecha de fin del rango (incluida). Formato ISO 8601:{' '}
                    <code style={S.codeBadge}>YYYY-MM-DD</code>
                  </td>
                </tr>
              </tbody>
            </table>

            <h4 style={{ ...S.sectionTitle, marginTop: 22 }}>Ejemplo de cuerpo</h4>
            <div style={{ position: 'relative' }}>
              <CopyButton text={`{\n  "MachineType": "lockers",\n  "StartDate": "2024-01-01",\n  "EndDate": "2024-01-31"\n}`} />
              <pre style={S.codeBlock}>{`{
  "MachineType": "lockers",
  "StartDate": "2024-01-01",
  "EndDate": "2024-01-31"
}`}</pre>
            </div>
          </div>
        </div>

        {/* ── Responses ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-reply" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Respuestas</h3>
          </div>
          <div style={S.cardBody}>
            <div style={S.responseRow}>
              <span style={S.badge200}>200 OK</span>
              <span style={S.responseDesc}>
                Archivo de texto plano (<code style={S.codeBadge}>text/plain; charset=utf-8</code>)
                con las ventas en formato CSV. Se descarga con el header{' '}
                <code style={S.codeBadge}>Content-Disposition: attachment</code>.
              </span>
            </div>
            <div style={S.responseRow}>
              <span style={S.badge401}>401 Unauthorized</span>
              <span style={S.responseDesc}>
                Token ausente o inválido.{' '}
                <code style={S.codeBadge}>{`{ "message": "Unauthorized Token" }`}</code>
              </span>
            </div>
            <div style={S.responseRow}>
              <span style={S.badge400}>400 Bad Request</span>
              <span style={S.responseDesc}>
                Algún campo requerido falta o es incorrecto.{' '}
                <code style={S.codeBadge}>{`{ "message": "..." }`}</code>
              </span>
            </div>
            <div style={{ ...S.responseRow, borderBottom: 'none' }}>
              <span style={S.badge400}>500 Server Error</span>
              <span style={S.responseDesc}>
                Error interno del servidor.{' '}
                <code style={S.codeBadge}>{`{ "message": "Internal Server Error" }`}</code>
              </span>
            </div>
          </div>
        </div>

        {/* ── CSV format ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-table" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Formato del CSV de respuesta</h3>
          </div>
          <div style={S.cardBody}>
            <p style={S.para}>
              La primera línea es la cabecera con los nombres de columna. Los campos están
              separados por <strong>coma (,)</strong> y el salto de línea es{' '}
              <code style={S.codeBadge}>CRLF</code> (<code style={S.codeBadge}>\r\n</code>).
            </p>
            <pre style={{ ...S.codeBlock, marginBottom: 18, fontSize: 11 }}>
              COMPLETE NAME,FISCAL NAME,ADDRESS,ZIP CODE,CITY,PROVINCE,VAT NUMBER,POS ID,INVOICE,DATE,TIME,PRODUCT,QUANTITY,UNIT PRICE,BASE PRICE,VAT %,VAT PRICE,TIPO PAGO,TOTAL
            </pre>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={{ ...S.th, width: 160 }}>Columna</th>
                  <th style={S.th}>Descripción</th>
                </tr>
              </thead>
              <tbody>
                {CSV_COLUMNS.map(({ col, desc }) => (
                  <tr key={col}>
                    <td style={S.td}><code style={S.codeBadge}>{col}</code></td>
                    <td style={S.td}>{desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Code examples ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-code" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Ejemplos de código</h3>
          </div>
          <div style={S.cardBody}>
            <div style={S.tabBar}>
              {Object.entries(EXAMPLES).map(([key, { label }]) => (
                <button
                  key={key}
                  style={S.tabBtn(activeTab === key)}
                  onClick={() => setActiveTab(key)}
                >
                  {label}
                </button>
              ))}
            </div>
            <div style={{ position: 'relative' }}>
              <CopyButton text={EXAMPLES[activeTab].code} />
              <pre style={S.codeBlock}>{EXAMPLES[activeTab].code}</pre>
            </div>
          </div>
        </div>

        {/* ── Interactive form ── */}
        <div style={S.card}>
          <div style={{ ...S.cardHeader, background: '#003d6b' }}>
            <i className="fa fa-play-circle" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Probar petición</h3>
          </div>
          <div style={S.cardBody}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={() => {
                  setStartDate('2025-08-07');
                  setEndDate('2025-08-07');
                  setAuthToken('620d1664db950220fabc0a41');
                }}
                style={{
                  background: 'transparent',
                  border: '1px dashed #ffae00',
                  borderRadius: 6,
                  padding: '10px 14px',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#856404',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  flexShrink: 0,
                }}
              >
                <i className="fa fa-flask" />
                Datos de prueba Vacway
              </button>
              <div style={{ ...S.tokenHint, marginBottom: 0, flex: 1 }}>
                <i className="fa fa-info-circle" style={{ marginTop: 2, flexShrink: 0 }} />
                <span>
                  Introduce tu <strong>token de cliente</strong> (Customer token). Este token
                  te será proporcionado por el staff de onboarding o por el equipo técnico que
                  te dé soporte.
                </span>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={S.formGrid}>
                {/* MachineType (fixed) */}
                <div style={{ ...S.formGridFull }}>
                  <label style={S.label}>
                    <i className="fa fa-lock" style={{ marginRight: 6, color: '#ffae00' }} />
                    Tipo de máquina
                    <span style={{ ...S.fixedBadge, marginLeft: 8 }}>FIJO</span>
                  </label>
                  <input
                    style={S.inputReadonly}
                    type="text"
                    value="lockers"
                    readOnly
                  />
                </div>

                {/* StartDate */}
                <div>
                  <label style={S.label}>
                    <i className="fa fa-calendar" style={{ marginRight: 6 }} />
                    Fecha inicio <span style={S.requiredBadge}>requerido</span>
                  </label>
                  <input
                    style={S.input}
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>

                {/* EndDate */}
                <div>
                  <label style={S.label}>
                    <i className="fa fa-calendar-check-o" style={{ marginRight: 6 }} />
                    Fecha fin <span style={S.requiredBadge}>requerido</span>
                  </label>
                  <input
                    style={S.input}
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                  />
                </div>

                {/* Auth token */}
                <div style={S.formGridFull}>
                  <label style={S.label}>
                    <i className="fa fa-shield" style={{ marginRight: 6 }} />
                    Token de autorización <span style={S.requiredBadge}>requerido</span>
                  </label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input
                      style={{ ...S.input, flex: 1, fontFamily: 'monospace', fontSize: 12 }}
                      type={showToken ? 'text' : 'password'}
                      value={authToken}
                      onChange={(e) => setAuthToken(e.target.value)}
                      placeholder="Pega aquí tu Bearer token..."
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowToken(!showToken)}
                      style={{
                        background: '#e8edf5',
                        border: '1px solid #cdd5e0',
                        borderRadius: 6,
                        padding: '0 14px',
                        cursor: 'pointer',
                        color: '#4a5568',
                        fontSize: 13,
                        flexShrink: 0,
                      }}
                      title={showToken ? 'Ocultar token' : 'Mostrar token'}
                    >
                      <i className={`fa fa-eye${showToken ? '-slash' : ''}`} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    ...S.submitBtn,
                    opacity: loading ? 0.7 : 1,
                    cursor: loading ? 'not-allowed' : 'pointer',
                  }}
                >
                  {loading
                    ? <><i className="fa fa-spinner fa-spin" /> Enviando petición…</>
                    : <><i className="fa fa-paper-plane" /> Enviar petición y descargar CSV</>
                  }
                </button>
                {result && result.ok && (
                  <span style={{ fontSize: 13, color: '#2d6a4f', fontWeight: 500 }}>
                    <i className="fa fa-check-circle" style={{ marginRight: 5 }} />
                    {result.lineCount === 1
                      ? '1 venta encontrada'
                      : `${result.lineCount} ventas encontradas`}
                    {autoDownloaded && ' · Descarga iniciada automáticamente'}
                  </span>
                )}
              </div>
            </form>

            {/* Result preview */}
            {result && (
              <div>
                <div style={{ marginTop: 18, marginBottom: 6, fontSize: 13, fontWeight: 600, color: '#001d3a' }}>
                  {result.ok ? 'Vista previa de la respuesta:' : 'Respuesta de error:'}
                </div>
                <div style={S.resultBox(result.ok)}>
                  {result.ok
                    ? result.text.split('\n').slice(0, 8).join('\n') +
                      (result.text.split('\n').length > 8 ? '\n… (truncado)' : '')
                    : result.text
                  }
                </div>
                {result.ok && (
                  <button
                    onClick={() => {
                      const blob = new Blob([result.text], { type: 'text/plain;charset=utf-8' });
                      const url  = URL.createObjectURL(blob);
                      const a    = document.createElement('a');
                      a.href     = url;
                      a.download = `sales-lockers-${startDate}-${endDate}.txt`;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }}
                    style={{
                      marginTop: 10,
                      background: '#28a745',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      padding: '8px 18px',
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <i className="fa fa-download" /> Descargar CSV de nuevo
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Rate Limits & Notes ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <i className="fa fa-lightbulb-o" style={S.cardHeaderIcon} />
            <h3 style={S.cardHeaderTitle}>Notas y buenas prácticas</h3>
          </div>
          <div style={S.cardBody}>
            <ul style={{ color: '#4a5568', fontSize: 14, lineHeight: 1.9, paddingLeft: 20, margin: 0 }}>
              <li>
                Los rangos de fecha muy amplios (más de 3 meses) pueden generar archivos grandes.
                Se recomienda dividir las consultas en períodos mensuales.
              </li>
              <li>
                El archivo devuelto usa codificación <strong>UTF-8</strong>. Para abrirlo
                correctamente en Excel, importa el archivo y selecciona UTF-8 como codificación.
              </li>
              <li>
                Los separadores decimales en los campos de precio utilizan el <strong>punto (.)</strong>
                {' '}como separador decimal.
              </li>
              <li>
                El campo <code style={S.codeBadge}>POS ID</code> puede ser el número de serie
                de la máquina (kiosco) o el código del QR/PDA si el pago se realizó por esos medios.
              </li>
              <li>
                Si el rango no contiene ventas, la respuesta será únicamente la línea de cabecera.
              </li>
            </ul>
          </div>
        </div>

        </>)}

        {activeSection === 'redeemcodes' && (
          <RedeemCodesSection role={role} customer={customer} />
        )}

      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  role:     state.auth.role,
  customer: state.customers.customer,
});

export default connect(mapStateToProps)(ApiDocsView);
